/*!
 * Copyright © 2020-2026. Verizon Connect Ireland Limited. All rights reserved.
 */

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ICompleteBody, IInitialiseBody, IInitialiseResponse } from '../models';
import { UrlsService } from './urls.service';

@Injectable()
export class SetPasswordService {
  constructor(@Inject(LOCALE_ID) public locale: string, private readonly http: HttpClient, private readonly urlsService: UrlsService) {}

  private postHeader(): HttpHeaders {
    return new HttpHeaders({
      Accept: 'application/json',
      'Content-Type': 'application/json'
    });
  }

  private postRequest<TBody, TResponse>(action: string, url: string, body: TBody): Observable<TResponse> {
    return this.http
      .post<TResponse>(url, body, {
        headers: this.postHeader(),
        responseType: 'json'
      })
      .pipe(
        map((response: TResponse) => response),
        catchError((error: HttpErrorResponse) => throwError(error))
      );
  }

  public initialiseSetPassword(username: string): Observable<IInitialiseResponse> {
    return this.postRequest<IInitialiseBody, IInitialiseResponse>('initialiseSetPassword', this.urlsService.initialiseApiUrl, {
      username,
      locale: this.locale
    });
  }

  public completeSetPassword(sessionToken: string, password: string, verificationCode: string): Observable<null> {
    return this.postRequest<ICompleteBody, null>('completeSetPassword', this.urlsService.completeApiUrl, {
      sessionToken,
      password,
      verificationCode
    });
  }
}
